import React, {ChangeEvent, useEffect, useState} from 'react';
import {Flex, Form, Input} from "antd";
import styles from './Profile.module.scss';
import UploadAvatar from "./components/UploadAvatar/UploadAvatar";
import useCreatePersonalForm from "../../../../hooks/useCreatePersonalForm";
// @ts-ignore
import { ReactComponent as ChevronIcon } from '../../../../assets/images/global-icons/chevron_ic.svg'
import CustomButton from "../../../../components/UI/CustomButton/CustomButton";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../../redux/store"
import {useNavigate} from "react-router";
import { login } from '../../../../redux/isAuthSlice';
import {useGetMeQuery, useUpdateProfileMutation} from "../../../../redux/API/userSlice";
import CompanyEmailsModal from "./components/CompanyEmailsModal/CompanyEmailsModal";
import {
  useCreateCompanyMutation,
  useSearchCompanyMutation, useSendJoinRequestMutation, useSendVerificationCompanyMailMutation
} from "../../../../redux/API/companySlice";
import CompanyVerificationModal from "./components/CompanyVerificationModal/CompanyVerificationModal";
import NonVerifyCompanyModal from "./components/NonVerifyCompanyModal/NonVerifyCompanyModal";
import CompanySearchModal from "./components/CompanySearchModal/CompanySearchModal";

interface Company {
  companyName: string;
  companyEmail: string;
  companyAddress: string;
  imageUrl: string;
  placeId: string;
  emailName: string;
  link: string;
  address: string;
  picture: string;
  id: string | null;
}

const Profile = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState<string>('');
  const [avatar, setAvatar] = useState<string>('');
  const [companyName, setCompanyName] = useState('');
  const [companyEmail, setCompanyEmail] = useState('');
  const [isCompanyListOpen, setIsCompanyListOpen] = useState(false);
  const [isCompanyModalOpen, setIsCompanyModalOpen] = useState(false);
  const [isVerificationCompanyModalOpen, setIsVerificationCompanyModalOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [isCompanyVerify, setIsCompanyVerify] = useState(false);
  const [companyData, setCompanyData] = useState<any>();
  const [isNonVerifyCompanyModalOpen, setIsNonVerifyCompanyModalOpen] = useState(false);
  const [isCompanySearchModalOpen, setIsCompanySearchModalOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const formState = useSelector((state: RootState) => state.form);

  const {data: userData} = useGetMeQuery({accessToken: formState.accessToken})
  const [searchCompany, {data, isLoading}] = useSearchCompanyMutation();
  const [createCompany] = useCreateCompanyMutation();
  const [sendJoinRequest] = useSendJoinRequestMutation();
  const [sendVerificationCompanyMail] = useSendVerificationCompanyMailMutation();
  const [updateProfile] = useUpdateProfileMutation();

  const {
    form,
    onFinish,
    isDisabledBtn
  } = useCreatePersonalForm();

  useEffect(() => {
    form.setFieldValue('company', selectedCompany)
  }, [selectedCompany]);

  useEffect(() => {
    form.setFieldValue('avatar', avatar)
  }, [avatar]);

  const handleCompanyClick = async (placeId: string, companyName: string) => {
    try {
      setIsCompanySearchModalOpen(false);
      setIsCompanyModalOpen(true);
      setSelectedCompany(placeId);
      setCompanyName(companyName);
      setIsCompanyListOpen(false);
      await searchCompany({ placeId }).unwrap();
    } catch (error) {
      console.error('Error searching company:', error);
    }
  };


  const handleCompanyEmailClick = async (company: Company) => {
    try {
      if(!company.id) {
        setIsCompanyVerify(false);
        const createdCompany = await createCompany({
          body: {
            companyName: company.companyName,
            address: company.companyAddress,
            phone: '+1-555-123-4567',
            website: company.link,
            dunsNumber: '123456789',
            placeId: company.placeId,
            email: company.companyEmail,
            link: `https://linkedin.com/company/${company.companyName}`,
            pictures: company.imageUrl,
            isValidate: false,
            description: ''
          },
          accessToken: formState.accessToken
        }).unwrap();

        setCompanyData(createdCompany?.data);

        await sendJoinRequest({
          body: {
            userId: userData?.data.id,
            companyId: createdCompany?.data.id
          },
          accessToken: formState.accessToken
        }).unwrap()

        await sendVerificationCompanyMail({
          name: company.companyName,
          email: company.companyEmail
        }).unwrap()
      } else {
        setIsCompanyVerify(true);
        setCompanyData(company)

        await sendJoinRequest({
          body: {
            userId: userData?.data.id,
            companyId: company.id
          },
          accessToken: formState.accessToken
        }).unwrap()
      }

      setIsVerificationCompanyModalOpen(true);
      setCompanyEmail(company.companyEmail);
    } catch (error) {
      console.error(error);
    }
  }

  const handleSubmit = async () => {
    try {
      await onFinish()

      const updateProfileData = {
        avatarKey: form.getFieldValue('avatar') || '',
        firstName: form.getFieldValue('firstName') || '',
        lastName: form.getFieldValue('lastName') || '',
        phone: `1${formState?.phone}` || '',
      };

      await updateProfile({
        body: updateProfileData,
        id: userData?.data.id,
        accessToken: formState.accessToken
      }).unwrap()

      if (isCompanyVerify) {
        dispatch(
          login({
            token: formState?.accessToken,
          })
        );
        navigate('/');
      } else {
        setIsNonVerifyCompanyModalOpen(true);
      }
    } catch (error: any) {
      console.log(error)
      setErrorMsg(error?.data.error.description);
    }
  }

 const handleNameChange = (e: ChangeEvent<HTMLInputElement>) => {
  const fieldName = e.target.id;
  const inputValue = e.target.value;

  const cleaned = inputValue
    .replace(/[^a-zA-Zа-яА-ЯёЁїЇіІєЄґҐ\s'\-]/g, '')
    .replace(/\s+/g, ' ')
    .replace(/^\s+/, '');

  form.setFieldValue(fieldName, cleaned);
};

  return (
    <Flex className={styles.Profile__wrapper} justify="center" align="center">
      <CompanyEmailsModal
        onCompanyClick={(company: Company) => handleCompanyEmailClick(company)}
        visible={isCompanyModalOpen}
        isLoading={isLoading}
        onClose={() => setIsCompanyModalOpen(false)}
        companies={data?.data}
        onBack={() => {
          setIsCompanyModalOpen(false);
          setIsCompanySearchModalOpen(true);
        }}
      />
      <CompanySearchModal
        visible={isCompanySearchModalOpen}
        onClose={() => setIsCompanySearchModalOpen(false)}
        onCompanyClick={() => {}}
        companyName={companyName}
        handleCompanyClick={handleCompanyClick}
        setCompanyName={setCompanyName}
        isCompanyListOpen={isCompanyListOpen}
        setIsCompanyListOpen={setIsCompanyListOpen}
      />
      <CompanyVerificationModal visible={isVerificationCompanyModalOpen} onClose={() => setIsVerificationCompanyModalOpen(false)} />
      <NonVerifyCompanyModal visible={isNonVerifyCompanyModalOpen} onClose={() => {
        setIsNonVerifyCompanyModalOpen(false);
        dispatch(
          login({
            token: formState?.accessToken,
          })
        );
        navigate('/');
      }} />
      <Flex className={styles.Profile} justify="center" align="center" vertical gap={'80px'}>
        <Flex className={styles.Profile__header} vertical justify="center" align="center" gap="16px">
          <h1>Create New Account</h1>
          <p>Add more information about yourself</p>
        </Flex>
        <Form
          className={styles.Profile__form}
          layout="vertical"
          form={form}
          //initialValues={initialValues}
          onFinish={handleSubmit}
        >
          <Form.Item
            name={"avatar"}
          >
            <Flex justify={"center"}>
              <UploadAvatar setAvatar={setAvatar}/>
            </Flex>
          </Form.Item>
          <Form.Item label="Your First Name"
                     name={"firstName"}
                     rules={[
                       { required: true, message: "This field is required" },
                       { min: 2, message: "Minimum 2 characters" },
                       { max: 20, message: "Maximum 20 characters" },
                       {
                         pattern: /^[^\s][a-zA-Z0-9&“\-_. ]*$/,
                         message: "Invalid characters or starts with whitespace"
                       },
                       {
                         validator: (_, value) =>
                           value && /\s{2,}/.test(value)
                             ? Promise.reject("No double spaces allowed")
                             : Promise.resolve()
                       }
                     ]}
          >
            <Input
              placeholder="First name"
              className={styles.Profile__form__input}
              onChange={handleNameChange}
            />
          </Form.Item>

          <Form.Item label="Your Last Name"
                     name={"lastName"}
                     rules={[
                       { required: true, message: "This field is required" },
                       { min: 2, message: "Minimum 2 characters" },
                       { max: 20, message: "Maximum 20 characters" },
                       {
                         pattern: /^[^\s][a-zA-Z0-9&“\-_. ]*$/,
                         message: "Invalid characters or starts with whitespace"
                       },
                       {
                         validator: (_, value) =>
                           value && /\s{2,}/.test(value)
                             ? Promise.reject("No double spaces allowed")
                             : Promise.resolve()
                       }
                     ]}
          >
            <Input
              placeholder="Last name"
              className={styles.Profile__form__input}
              onChange={handleNameChange}
            />
          </Form.Item>

          <Form.Item label="Where do you work?"
                     name="company"
                     rules={[
                       {
                         required: true,
                         message: 'company name is required'
                       }
                     ]}
          >
            <Flex vertical gap={'20px'}>
              <Input
                placeholder="Choose a company"
                className={styles.Profile__form__input}
                suffix={<ChevronIcon />}
                value={companyName}
                onClick={() => setIsCompanySearchModalOpen(true)}
              />
              {
                (!isCompanyVerify && companyName) &&
                  <span>Your workspace is not verified. When your company profile is registered in this app, you can verity it in the settings</span>
              }
            </Flex>
          </Form.Item>
          <Form.Item>
            <Flex vertical align={"center"} className={styles.Profile__button}>
              <CustomButton
                text={'Next'}
                disable={!form.getFieldValue('firstName') || !form.getFieldValue('lastName') || !companyEmail}
                htmlType="submit"
              />
              {
                errorMsg && <p>{errorMsg}</p>
              }
            </Flex>
          </Form.Item>
        </Form>
      </Flex>
    </Flex>
  );
};

export default Profile;